import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const AuthCallback = ({ onSuccess }) => {
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const name  = params.get('name');
    const email = params.get('email');
    if (token) {
      loginWithToken({ token, name, email });
      window.history.replaceState({}, '', '/');
      onSuccess();
    } else {
      window.location.href = '/';
    }
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <p style={{ color: '#64748b', fontFamily: "DM Sans, sans-serif", fontSize: 15 }}>Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
